import { PublicKey } from "@solana/web3.js";
import type { NormalizedTokenAccount } from "@stepfinance/tokens";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useLiquidity, useOwnedPools } from "../../contexts/liquidity";
import { useNavigationContext } from "../../contexts/navigation";
import { AddToLiquidity } from "../Pool/AddToLiquidity";
import { RemoveLiquidity } from "../Pool/RemoveLiquidity";

export type LiquidityAction = "add" | "remove";
export interface LiquidityProps {
  action?: LiquidityAction;
}

export const Liquidity: FC<LiquidityProps> = (props) => {
  const { action: actionURLParam } = useParams<{ action?: LiquidityAction }>();
  const action = actionURLParam ? actionURLParam : props.action ?? "add";
  const { navigate } = useNavigationContext();
  const { stepFinancePools } = useLiquidity();
  const [poolMintAddress, setPoolMintAddress] = useState<PublicKey>();
  const pools = useOwnedPools();
  const pool = poolMintAddress ? stepFinancePools[poolMintAddress.toBase58()] : undefined;

  const accountPoolMap = pools.reduce(function (map, obj) {
    const key = obj.pool.mintAddress.toString();
    const accounts = map.has(key) ? map.get(key)! : [];
    accounts.push(obj.account);
    map.set(key, accounts);
    return map;
  }, new Map<string, NormalizedTokenAccount[]>());

  const accounts = poolMintAddress ? accountPoolMap.get(poolMintAddress?.toBase58()) ?? [] : [];

  useEffect(() => {
    if (action === "remove" && !pool) {
      navigate(`/liquidity/add`);
    }
  }, [action, pool, navigate]);

  return (
    <>
      {action === "add" && (
        <AddToLiquidity
          pool={pool}
          onPoolLiquidityAction={(action, updatedPool) => {
            setPoolMintAddress(updatedPool?.mintAddress ? new PublicKey(updatedPool?.mintAddress) : undefined);
            if (action !== "add") {
              navigate(`/liquidity/remove`);
            }
          }}
        />
      )}
      {action === "remove" && <RemoveLiquidity pool={pool} accounts={accounts} />}
    </>
  );
};
